import { PmOfferLaborExtra } from '@/DTOS/PmOffer/PmOfferLaborExtra';
import { PmOffer } from '@/DTOS/PmOffer/Response/PmOffer';
import { Divider, Drawer, Table, Tag } from 'antd';
import { PmOfferWorkPlaceItem } from 'DTOS/PmOffer/Response/PmOfferWorkPlaceItem';
import moment from 'moment';
import React from 'react';
import { Column } from '../../utils/column';

interface PmOfferInformationProps {
  handleModalInformationClose: () => void;
  modalInformation: boolean;
  selectedRecord: PmOffer | null;
}

const PmOfferInformation: React.FC<PmOfferInformationProps> = ({
  handleModalInformationClose,
  modalInformation,
  selectedRecord,
}) => {
  const isSmallScreen = window.innerWidth <= 720;
  const intervalColumns: Column[] = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'PmOffer Id',
      dataIndex: 'pmOfferId',
      key: 'pmOfferId',
      hidden: true,
    },
    {
      title: 'Data',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
    },
  ];

  const deviceColumns: Column[] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'Denumire',
      dataIndex: ['device', 'name'],
      key: 'deviceName',
      render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
      title: 'Model',
      dataIndex: ['device', 'model'],
      key: 'model',
    },
    {
      title: 'Bucati',
      dataIndex: 'piece',
      key: 'piece',
    },
    {
      title: 'Pret/Device',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Pret Total',
      dataIndex: '',
      key: 'total',
      render: (_text: string, record: PmOfferWorkPlaceItem) => record.piece * record.price,
    },
    {
      title: 'Persoana Contact',
      dataIndex: ['pmOfferWorkPlaceMetadata', 'agent', 'name'],
      key: 'contactPerson',
    },
    {
      title: 'Locatia',
      dataIndex: ['pmOfferWorkPlaceMetadata', 'workPlace', 'name'],
      key: 'location',
    },
  ];

  const laborExtraColumns: Column[] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'Labor Extra Name',
      dataIndex: ['laborExtra', 'name'],
      key: 'laborExtraName',
      render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
      title: 'Bucati',
      dataIndex: 'piece',
      key: 'piece',
    },
    {
      title: 'Pret',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Pret Total',
      dataIndex: '',
      key: 'total',
      render: (record: PmOfferLaborExtra) => record.piece * record.price,
    },
    {
      title: 'Unit Measure',
      dataIndex: 'unitMeasure',
      key: 'unitMeasure',
    },
  ];

  return (
    <Drawer
      title={`Informatii suplimentare`}
      placement={'right'}
      onClose={handleModalInformationClose}
      open={modalInformation}
      width={isSmallScreen ? '95%' : '50%'}
      key={'drawer_right'}
    >
      <h2>Oferta Nr. {selectedRecord?.number}</h2>
      <Tag color='purple' style={{ fontSize: 15 }}>
        {selectedRecord?.enumPmOfferStatus?.name}
      </Tag>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Client:</span>{' '}
        {selectedRecord?.metadata?.company?.name ?? selectedRecord?.company?.name}
      </p>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Data:</span> {moment(selectedRecord?.date).format('DD.MM.YYYY')}
      </p>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Data Interval:</span>{' '}
        {moment(selectedRecord?.dateStart).format('DD.MM.YYYY')} -{' '}
        {moment(selectedRecord?.dateEnd).format('DD.MM.YYYY')}
      </p>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Observatii:</span> {selectedRecord?.remarks}
      </p>

      <Divider />

      <h2>Intervale</h2>
      <Table
        bordered
        pagination={false}
        columns={intervalColumns}
        dataSource={selectedRecord?.pmOfferIntervals || []}
        scroll={{
          x: 'calc(600px + 80%)',
          y: 560,
        }}
        rowKey='id'
      />

      <h2>Device</h2>
      <Table
        bordered
        pagination={false}
        columns={deviceColumns}
        dataSource={selectedRecord?.pmOfferWorkPlaceItems || []}
        scroll={{
          x: 'calc(600px + 80%)',
          y: 560,
        }}
        rowKey='id'
      />

      <h2>Manopera</h2>
      <Table
        bordered
        pagination={false}
        columns={laborExtraColumns}
        dataSource={selectedRecord?.pmOfferLaborExtras || []}
        scroll={{
          x: 'calc(600px + 80%)',
          y: 560,
        }}
        rowKey='id'
      />
    </Drawer>
  );
};

export default PmOfferInformation;
